import axiosNew from '../../../helpers/axios'

import { buildCapacityDashboardPayload } from './capacity.utils'

export const fetchCapacityDashboard = async (params = {}) => {
    return axiosNew({
        url: 'support/reports/capacity/dashboard',
        method: 'POST',
        data: buildCapacityDashboardPayload(params),
    })
}
